export const TEST_USER_SEARCH_PARAM = 'testUser'

export interface AccountV2TestUserSearch {
  testUser?: string
}

export function nonEmptySearchString(value: unknown): string | undefined {
  return typeof value === 'string' && value.length > 0 ? value : undefined
}

export function getTestUserFromCurrentUrl(): string | null {
  if (typeof window === 'undefined') return null
  return new URLSearchParams(window.location.search).get(TEST_USER_SEARCH_PARAM)
}

export function withCurrentTestUserSearchParam(href: string): string {
  const testUser = getTestUserFromCurrentUrl()
  if (!testUser) return href

  let url: URL
  try {
    url = new URL(href, window.location.origin)
  } catch {
    return href
  }

  if (url.origin !== window.location.origin) return href
  if (!url.searchParams.has(TEST_USER_SEARCH_PARAM)) {
    url.searchParams.set(TEST_USER_SEARCH_PARAM, testUser)
  }

  const isAbsoluteUrl = /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(href)
  return isAbsoluteUrl ? url.toString() : `${url.pathname}${url.search}${url.hash}`
}

function isMeaningfulSandboxRoute(pathname: string): boolean {
  return pathname !== '/' && pathname !== '/login' && pathname !== '/signup'
}

export function buildTestUserRouteForCurrentPage(uid: string): string {
  const current = new URL(window.location.href)
  const pathname = isMeaningfulSandboxRoute(current.pathname) ? current.pathname : '/workspaces'
  const target = new URL(`${pathname}${current.search}${current.hash}`, window.location.origin)
  target.searchParams.set(TEST_USER_SEARCH_PARAM, uid)
  return `${target.pathname}${target.search}${target.hash}`
}

export function buildTestUserUrlForCurrentPage(uid: string): string {
  return new URL(buildTestUserRouteForCurrentPage(uid), window.location.origin).toString()
}

export function buildDefaultTestUserRoute(uid: string): string {
  const target = new URL('/workspaces', window.location.origin)
  target.searchParams.set(TEST_USER_SEARCH_PARAM, uid)
  return `${target.pathname}${target.search}`
}

export function buildDefaultTestUserUrl(uid: string): string {
  return new URL(buildDefaultTestUserRoute(uid), window.location.origin).toString()
}
